<template>
  <div class="container-fluid mt-5">
    <div class="row">
      <div class="col-xl-12 order-xl-1">
        <card>
          <div slot="header" class="row align-items-center">
            <div class="col-8">
              <h3 class="mb-0">{{ $t("PACKAGES.EDIT_PACKAGE") }}</h3>
            </div>
            <div class="col-4 text-right">
              <base-button
                @click="goBack"
                type="button"
                class="btn btn-sm btn-primary"
              >
                {{ $t("COMMON.RETURN_TO_LIST") }}
              </base-button>
            </div>
          </div>
          <div class="card-body">
            <package-form
              :loading="loading"
              :packData="pack"
              :formErrors="formErrors"
              @packSubmitted="handleSubmit"
              @formChanged="() => (alertLeave = true)"
            />
          </div>
        </card>
      </div>
    </div>
  </div>
</template>

<script>
import PackageForm from "./partials/PackageForm.vue";
import { cloneDeep } from "lodash";
import alertLeave from "@/mixins/alert-leave-mixin";
import defaultPackage from "./defaultPackage";

export default {
  layout: "DashboardLayout",

  components: { PackageForm },

  mixins: [alertLeave],

  data() {
    return {
      pack: cloneDeep(defaultPackage),
      formErrors: null,
      loading: false,
    };
  },

  created() {
    this.get();
  },

  methods: {
    async get() {
      this.loading = true;
      try {
        const id = this.$route.params.id;
        await this.$store.dispatch("packages/get", id);
        this.pack = this.$store.getters["packages/package"];
        this.loading = false;
      } catch (error) {
        this.$notify({
          type: "danger",
          message: this.$t("ERRORS.SOMETHING_WENT_WRONG"),
        });
        this.loading = false;
      }
    },

    goBack() {
      this.$router.push({ name: "List Packages" });
    },

    viewPack() {
      this.alertLeave = false;
      this.$router.push({
        name: "View Package",
        params: { id: this.pack.id },
      });
    },

    async handleSubmit(pack) {
      this.loading = true;
      const packData = cloneDeep(pack);

      try {
        await this.$store.dispatch("packages/update", packData);
        this.$notify({
          type: "success",
          message: this.$t("PACKAGES.PACKAGE_UPDATED"),
        });
        this.viewPack();
        this.loading = false;
      } catch (error) {
        this.$notify({
          type: "danger",
          message: this.$t("ERRORS.SOMETHING_WENT_WRONG"),
        });
        this.formErrors = error.response.data.errors;
        this.loading = false;
      }
    },
  },
};
</script>
